const reasonNameAcronyms = ['FMC', 'PM', 'PMI', 'SLA'];

const toReasonName = (key) => key
    .split('_')
    .map(word => reasonNameAcronyms.includes(word) ? word : `${word.charAt(0)}${word.slice(1).toLowerCase()}`)
    .join(' ');

export const workRequestActions = {
    SEND_TECHNICIAN: 'sendTechnician',
    COMPLETE: 'complete',
    DRY_RUN: 'dryRun',
    REJECT: 'reject',
    DELAY: 'delay',
    CANCEL: 'cancel',
    ACCEPT_CANCELLATION: 'cancel/accept',
    REJECT_CANCELLATION: 'cancel/reject',
    ESTIMATE: 'estimate',
};

export const arrivalTypes = {
    EXPECTED_ARRIVAL: 1,
    ACTUAL_ARRIVAL: 2,
};

export const rejectionReasons = {
    AMAZON_CANCELLED: 1,
    ASSET_NOT_IN_SYSTEM: 2,
    ASSET_NOT_ON_SITE: 3,
    ASSET_UNAVAILABLE: 4,
    CREATED_IN_ERROR: 5,
    DAMAGE_UNCLEAR: 6,
    DEFERRABLE_DEFECT: 7,
    DISTANCE_TOO_GREAT: 8,
    DUPLICATE: 9,
    EVENT_NOT_DUE: 10,
    FINANCE_ISSUE: 11,
    FMC_ESTIMATE_REJECTED: 12,
    INCLEMENT_WEATHER: 13,
    INSUFFICIENT_CAPACITY: 14,
    INVALID_LOCATION: 15,
    INVALID_REQUEST: 16,
    MAPPING_ERROR: 17,
    NOT_AUTHORIZED_FOR_TURNPIKE: 18,
    NO_ACCESS_TO_SITE: 19,
    NO_IMAGE: 20,
    OVERSCHEDULED: 21,
    PMI_EVENT: 22,
    SAFETY_CONCERN: 23,
    SENT_IN_ERROR: 24,
    SITE_CLOSED: 25,
    UNAVAILABLE_PRODUCT: 26,
    VENDOR_CANCELLED_WORK_ORDER: 27,
    VENDOR_DECLINED_WORK: 28,
    VENDOR_ISSUE: 29,
    VENDOR_SERVER_ERROR: 30,
    WORK_OUT_OF_SCOPE: 31,
};

export const rejectionReasonOptions = Object.entries(rejectionReasons)
    .map(([name, id]) => ({ id, name: toReasonName(name) }));

export const delayReasons = {
    ADDITIONAL_WORK_NEEDED: 1,
    AMAZON_DELAY: 2,
    AMAZON_REQUESTED_ASSET: 3,
    ASSET_NOT_AVAILABLE: 4,
    AWAITING_ESTIMATE: 5,
    AWAITING_ESTIMATE_APPROVAL: 6,
    DELAYED_PREV_CALL: 7,
    EQUIPMENT_FAILURE: 8,
    GUARDSHACK_DELAY: 9,
    HOLIDAY: 10,
    INACCURATE_DETAILS: 11,
    INCLEMENT_WEATHER: 12,
    INCORRECT_ADDRESS: 13,
    PARTS_ON_BACK_ORDER: 14,
    PENDING_AMAZON_MOVE: 15,
    PENDING_VENDOR_MOVE: 16,
    PM_FAILED: 17,
    SOURCING_PARTS: 18,
    SPECIALIST_REQUIRED: 19,
    TECH_SHORTAGE: 20,
    TRAFFIC: 21,
    WAITING_FOR_DIAGNOSIS: 22,
    WARRANTY: 23,
    WORKSHOP_CAPACITY: 24,
};

export const delayReasonOptions = Object.entries(delayReasons)
    .map(([name, id]) => ({ id, name: toReasonName(name) }));

export const cancellationReasons = {
    ADDITIONAL_INFORMATION_REQUIRED: 1,
    ASSET_LEFT_YARD: 2,
    ASSET_NEEDED_FOR_OPERATION: 3,
    ASSET_UNAVAILABLE: 4,
    COMPLETED_OFFLINE: 5,
    CREATED_IN_ERROR: 6,
    DEFERRABLE_DEFECT: 7,
    DUPLICATE_ENTRY: 8,
    INCLEMENT_WEATHER: 9,
    LINKING_FAILED: 10,
    MOVED_TO_A_DIFFERENT_SYSTEM: 11,
    NOT_AN_ISSUE: 12,
    OTHER: 13,
    SAFETY_CONCERN: 14,
    VENDOR_CANCELLED_WORK_ORDER: 15,
    VENDOR_EXCEEDED_SLA: 16,
    VENDOR_NO_RESPONSE: 17,
    VENDOR_REJECTED: 18,
};

export const cancellationReasonOptions = Object.entries(cancellationReasons)
    .map(([name, id]) => ({ id, name: toReasonName(name) }));

export const workRequestSectionIds = {
    DISPATCH: 'dispatch',
    PROGRESS: 'progress',
    EXCEPTIONS: 'exceptions',
    CANCELLATION: 'cancellation',
};

export const workRequestSections = [
    { id: workRequestSectionIds.DISPATCH, label: 'Technician Dispatch' },
    { id: workRequestSectionIds.PROGRESS, label: 'Work Request Progress' },
    { id: workRequestSectionIds.EXCEPTIONS, label: 'Reject, Delay or Cancel' },
    { id: workRequestSectionIds.CANCELLATION, label: 'Cancellation Request' },
];

export const workRequestButtonLabels = {
    TECHNICIAN_EN_ROUTE: 'Send Technician en Route',
    TECHNICIAN_ARRIVAL: 'Send Technician Arrival',
    COMPLETE: 'Complete WO/WR',
    DRY_RUN: 'Simulate Dry Run',
    REJECT: 'Reject WR',
    DELAY: 'Delay Work Order',
    CANCEL: 'Cancel Work Request',
    ACCEPT_CANCELLATION: 'Accept Cancellation',
    REJECT_CANCELLATION: 'Reject Cancellation',
    SEND_ESTIMATE: 'Send Estimate',
};

export const expectedArrivalLabel = 'Expected Arrival Time';

export const actualArrivalLabel = 'Actual Arrival Time';

export const rejectionReasonLabel = 'Rejection Reason';

export const delayReasonLabel = 'Delay Reason';

export const cancellationReasonLabel = 'Cancellation Reason';

export const estimateFields = [
    { id: 'labor', label: 'Labor' },
    { id: 'parts', label: 'Parts' },
    { id: 'discounts', label: 'Discounts' },
    { id: 'taxes', label: 'Taxes' },
    { id: 'other', label: 'Other' },
];

export const estimateModalHeader = 'Send Estimate';

export const cancelLabel = 'Cancel';
